"use strict";

import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import AccountEmailFormInput from "./AccountEmailFormInput";
import formInputErrorClassName from "../../formInputErrorClassName";

const AccountEmailForm = ({email='', emailIsUnique=()=>{}, legend='Email',
                          onSubmit=()=>{}, onCancel=()=>{},children}) => {

    const [disabled, setDisabled] = useState(false);
    const {register, handleSubmit, watch, reset, formState: { errors, isValidating }} = useForm({
        defaultValues: {
            email: email,
        },
    });
    const watchEmail = watch("email", email);

    useEffect(()=>{
        reset({email: email});
    }, [email])

    useEffect(()=>{
        setDisabled(()=>{
            return watchEmail === email;
        });
    }, [email, watchEmail]);

    function handleCancelClick(e){
        e.preventDefault();
        reset({email: email});
        onCancel();
    }

    function formInputClassName(name = '') {
        return watchEmail !== email ? formInputErrorClassName(name, errors) : '';
    }

    return (
        <form id="account__email__form"
              className="account__email__form"
              onSubmit={handleSubmit(onSubmit)} noValidate >
            <AccountEmailFormInput legend={legend} register={register} errors={errors}
                                   formInputClassName={formInputClassName}
                                   isValidating={isValidating}
                                   emailIsUnique={emailIsUnique} />
            {!!children && React.Children.map(children, (child) => {
                const additionalProps = React.isValidElement(child) ? {visible: !disabled, onCancelClick: handleCancelClick,} : {};
                return(React.cloneElement(child, additionalProps));
            })}
        </form>
    );
};

export default AccountEmailForm;
